import { registrarEvento } from '@/services/googleAnalytics';
import { useEffect, useRef, useState } from 'react';

export default function useCabecalhoHomeHook() {
  const [menuLateralAberto, setMenuLateralAberto] = useState(false);

  const headerRef = useRef<HTMLDivElement>(null);
  const inputContainerRef = useRef<HTMLDivElement>(null);
  const distanciaTopoHeader = useRef(0);

  useEffect(() => {
    if (inputContainerRef?.current && headerRef?.current) {
      const inputPosition = inputContainerRef?.current.getBoundingClientRect();
      const headerPosition = headerRef?.current.getBoundingClientRect();

      distanciaTopoHeader.current = inputPosition.top - headerPosition.top;
    }
  }, []);

  function lidarMenuLateral() {
    if (!menuLateralAberto) {
      registrarEvento('clicou_menu_hamburger', {});
    }
    return setMenuLateralAberto((estadoAntigo) => !estadoAntigo);
  }

  return {
    menuLateralAberto,
    lidarMenuLateral,
    headerRef,
    inputContainerRef,
    distanciaTopoHeader,
  };
}
